import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'attach_department_groups';
export const useAttachDepartmentGroupsTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Добавить',
    search_placeholder: 'Поиск',
    loading: 'Загрузка',
    empty: 'Нет доступных групп',
    load_error: 'Не удалось загрузить группы',
    on_success: 'Группа прикреплена',
    on_error: 'Не удалось прикрепить группу',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Add',
    search_placeholder: 'Search',
    loading: 'Loading',
    empty: 'No groups available',
    load_error: 'Failed to load groups',
    on_success: 'Group attached',
    on_error: 'Failed to attach group',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Agregar',
    search_placeholder: 'Buscar',
    loading: 'Cargando',
    empty: 'No hay grupos disponibles',
    load_error: 'No se pudieron cargar los grupos',
    on_success: 'Grupo adjuntado',
    on_error: 'No se pudo adjuntar el grupo',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Adicionar',
    search_placeholder: 'Pesquisar',
    loading: 'Carregando',
    empty: 'Nenhum grupo disponível',
    load_error: 'Falha ao carregar os grupos',
    on_success: 'Grupo anexado',
    on_error: 'Falha ao anexar o grupo',
  },
}) as Record<string, unknown>;
